module.exports = __webpack_public_path__ + "static/conceptu-logo-8af938d7e082b31929704b12b3ee8da7.svg";